module.exports = __webpack_public_path__ + "media/images/fbcalls/btc_for_bg-0f4e6844756e2e60b5867f119abb615a.png";